<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section>
    <h3 class="text-center">Update Kiosk Item</h3>

    <!-- form -->
    <validation-observer ref="kioskValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
      >
        <validation-provider
          #default="{ errors }" name="Item name" rules="required">
          <label>Name*</label>
          <b-form-input
            v-model="item.name" class="mb-1" cy="item-name"
            :state="errors.length > 0 ? false:null"
            placeholder="Enter item name"
          />
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

<!--        <validation-provider-->
<!--          key="kiosk-locations"-->
<!--          #default="{ errors }"-->
<!--          name="Locations"-->
<!--          rules="required|require_locations"-->
<!--        >-->
          <label>Available Locations (required for social visits)</label>
          <multi-select
            id="kiosk-locations"
            v-model="selectedLocations"
            :options="socialVisitLocationsFormatted"
            :selected-options="selectedLocations"
            class="mb-1"
            placeholder="Select locations"
            @select="onSelectLocation"
            @remove="onSelectLocation"
          />
<!--          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>-->
<!--        </validation-provider>-->

        <label>Availability From</label>
        <b-form-timepicker
          v-model="availability_from"
          class="mb-1"
          placeholder="Select start time"
          cy="availability-from"
        />

        <validation-provider
          v-slot="{ errors }"
          name="Availability Until"
          :rules="{ is_after: availability_from }"
        >
          <label>Availability Until</label>
          <b-form-timepicker
            v-model="availability_until"
            class="mb-1"
            placeholder="Select end time"
            cy="availability-until"
          />
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

<!--        <validation-provider-->
<!--          #default="{ errors }" name="Item price" rules="required">-->
<!--          <label>Price*</label>-->
<!--          <b-form-input-->
<!--            v-model.number="item.price" class="mb-1" cy="item-price"-->
<!--            type="number"-->
<!--            :state="errors.length > 0 ? false:null"-->
<!--            placeholder="Enter item price"-->
<!--          />-->
<!--          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>-->
<!--        </validation-provider>-->

        <validation-provider
          #default="{ errors }" name="Item stock" rules="required">
          <b-form-checkbox switch cy="item-stock"
                           v-model="item.in_stock">In Stock
          </b-form-checkbox>
          <small>Note: If this is not checked it will not appear to users</small>
          <small class="text-danger d-block mb-1">{{ errors[0] }}</small>
        </validation-provider>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer"></div>
          <b-button class="mr-1" @click="close">Close</b-button>
          <b-button variant="success" @click="validationForm">Update Item</b-button>
        </section>
      </b-form>
    </validation-observer>
  </section>
</template>
<!--eslint-enable-->

<script>
import KioskService from '@/services/KioskService';
import { mapState } from 'vuex';
import VisitLocationsService from '@/services/VisitLocationsService';
import { MultiSelect } from 'vue-search-select/src/lib';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import moment from 'moment';

extend('require_locations', {
  validate(value) {
    return Array.isArray(value) && value.length > 0;
  },
  message: 'Please select at least one location.',
});

extend('is_after', {
  params: ['otherField'],
  validate(value, { otherField }) {
    if (!value || !otherField) return true;
    const thisTime = moment(value, 'HH:mm:ss');
    const otherTime = moment(otherField, 'HH:mm:ss');
    return thisTime.isAfter(otherTime);
  },
  message: 'Availability Until must be after Availability From.',
});

export default {
  components: {
    MultiSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    existingItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      socialVisitLocations: [],
      selectedLocations: [],
      item: {
        name: '',
        price: 1.50,
        in_stock: true,
        availability_from: null,
        availability_until: null,
        social_visit_location_ids: [],
      },
      availability_from: null,
      availability_until: null,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
    socialVisitLocationsFormatted() {
      if (!Array.isArray(this.socialVisitLocations)) return [];
      return this.socialVisitLocations.map(location => ({
        value: location._id,
        text: location.name,
      }));
    },
  },
  mounted() {
    this.item = { ...this.existingItem };

    if (this.item.availability_from) {
      this.availability_from = moment.utc(this.item.availability_from).format('HH:mm:ss');
    }
    if (this.item.availability_until) {
      this.availability_until = moment.utc(this.item.availability_until).format('HH:mm:ss');
    }

    this.getSocialVisitLocations();
  },
  methods: {
    validationForm() {
      this.$refs.kioskValidation.validate()
        .then(success => {
          if (success) {
            this.updateItem();
          }
        })
    },
    async getSocialVisitLocations() {
      try {
        const { data } = await VisitLocationsService.getVisitLocationsForPrison();
        this.socialVisitLocations = data;

        this.selectedLocations = this.socialVisitLocationsFormatted.filter(option => this.item.social_visit_location_ids.includes(option.value));
      } catch (error) {
        console.error('Error getting social visit locations:', error);
        this.$toast.error('Something went wrong while fetching locations, please try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        this.close();
      }
    },
    updateItem() {
      if (this.availability_from && this.availability_until) {
        this.item.availability_from = this.availability_from;
        this.item.availability_until = this.availability_until;
      }

      KioskService.updateKioskItem(this.prison.prison_id, this.item._id, this.item)
        .then(() => {
          this.$toast.success('Kiosk item successfully updated', {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.close();
        })
        .catch(() => {
          this.$toast.error('Something went wrong updating the kiosk item, please try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
    },
    onSelectLocation(selectedOptions) {
      this.selectedLocations = selectedOptions;
      this.item.social_visit_location_ids = selectedOptions.map(opt => opt.value);
    },
    close() {
      this.$emit('close', true);
    },
  },
};
</script>
